// Logo oficial de Centinela Salud como componente React
export default function CentinelaLogo({ className = "h-12 w-auto", showText = true }) {
  return (
    <svg
      viewBox="0 0 200 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Circulo verde principal */}
      <g transform="translate(10, 5)">
        <circle cx="35" cy="35" r="32" fill="#006847" stroke="#fff" strokeWidth="2"/>

        {/* Aguila estilizada */}
        <path d="M35 8 L48 20 L44 24 L35 16 L26 24 L22 20 Z" fill="#fff"/>
        <path d="M35 16 L42 26 L35 38 L28 26 Z" fill="#fff"/>

        {/* Familia - Padre */}
        <circle cx="24" cy="44" r="5" fill="#fff"/>
        <path d="M19 50 L19 62 Q19 65 22 65 L26 65 Q29 65 29 62 L29 50 Q29 47 24 47 Q19 47 19 50" fill="#fff"/>

        {/* Familia - Madre */}
        <circle cx="35" cy="42" r="6" fill="#fff"/>
        <path d="M28 49 L28 63 Q28 66 32 66 L38 66 Q42 66 42 63 L42 49 Q42 45 35 45 Q28 45 28 49" fill="#fff"/>

        {/* Familia - Padre 2 */}
        <circle cx="46" cy="44" r="5" fill="#fff"/>
        <path d="M41 50 L41 62 Q41 65 44 65 L48 65 Q51 65 51 62 L51 50 Q51 47 46 47 Q41 47 41 50" fill="#fff"/>
      </g>

      {/* Texto Centinela Salud */}
      {showText && (
        <>
          <text
            x="88"
            y="45"
            fontFamily="Arial Black, Arial, sans-serif"
            fontSize="28"
            fontWeight="900"
            fill="#006847"
          >
            CENTINELA SALUD
          </text>
          <text
            x="88"
            y="60"
            fontFamily="Arial, sans-serif"
            fontSize="7"
            fill="#006847"
            letterSpacing="0.5"
          >
            Centinela Salud
          </text>
        </>
      )}
    </svg>
  )
}

// Version solo icono (sin texto)
export function CentinelaLogoIcon({ className = "h-10 w-10" }) {
  return (
    <svg
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="35" cy="35" r="32" fill="#006847" stroke="#fff" strokeWidth="2"/>

      {/* Aguila estilizada */}
      <path d="M35 8 L48 20 L44 24 L35 16 L26 24 L22 20 Z" fill="#fff"/>
      <path d="M35 16 L42 26 L35 38 L28 26 Z" fill="#fff"/>

      {/* Familia - Padre */}
      <circle cx="24" cy="44" r="5" fill="#fff"/>
      <path d="M19 50 L19 62 Q19 65 22 65 L26 65 Q29 65 29 62 L29 50 Q29 47 24 47 Q19 47 19 50" fill="#fff"/>

      {/* Familia - Madre */}
      <circle cx="35" cy="42" r="6" fill="#fff"/>
      <path d="M28 49 L28 63 Q28 66 32 66 L38 66 Q42 66 42 63 L42 49 Q42 45 35 45 Q28 45 28 49" fill="#fff"/>

      {/* Familia - Padre 2 */}
      <circle cx="46" cy="44" r="5" fill="#fff"/>
      <path d="M41 50 L41 62 Q41 65 44 65 L48 65 Q51 65 51 62 L51 50 Q51 47 46 47 Q41 47 41 50" fill="#fff"/>
    </svg>
  )
}
